import { memo } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from 'src/components/buttons';
import { RequireLoginButton } from '../RequireLoginButton';
import { isBookmarkSeclector } from 'src/selectors/user';
import * as UserAction from 'src/redux/actions/user';

interface IProps {
    className?: string;
    contentId: number;
    classNameIcon?: string;
    classIconBookmark?: string;
}

const BookmarkButton = ({
    className,
    contentId,
    classNameIcon,
    classIconBookmark,
}: IProps) => {
    const isBookmark = useSelector(isBookmarkSeclector(contentId));
    const dispatch = useDispatch();

    const handleClick = () => {
        if (contentId) {
            dispatch(UserAction.bookmark(contentId));
        }
    };

    return (
        <RequireLoginButton onClickFn={handleClick}>
            <IconButton
                title="Lưu tin"
                className={cn('btn-bookmark', className)}
                classNameIcon={isBookmark ? classIconBookmark : classNameIcon}
                icon={
                    isBookmark ? 'new-bookmark-solid' : 'new-bookmark-regular'
                }
                text={isBookmark ? 'Tin đã được lưu' : 'Lưu tin'}
            />
        </RequireLoginButton>
    );
};

export default memo(BookmarkButton);
